import { NotiModal, NotiModalM } from '@components/Modal';
import FooterRouter from '@routes/FooterRouter';
import HeaderRouter from '@routes/HeaderRouter';
import MainRouter from '@routes/MainRouter';
import { useLanguage, useResponsive } from '@utils/hooks';
import { isWithinPopupAutoShowPeriod } from '@utils/serviceEndConfig';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default () => {
  const location = useLocation();
  const navigate = useNavigate();
  const deviceType = useResponsive();
  const language = useLanguage();
  const [showServiceEndModal, setShowServiceEndModal] = useState<boolean>(
    isWithinPopupAutoShowPeriod,
  );

  const closeServiceEndModal = () => {
    setShowServiceEndModal(false);
  };

  useEffect(() => {
    const changeSeoSetting = (lang: 'ko' | 'en') => {
      const TITLES = { ko: `블록챗`, en: `BlockChat` };
      const DESCRIPTIONS = {
        ko: `세계 최초 서버 없는 블록체인 메신저 블록챗`,
        en: `No Server Only Blockchain, BlockChat`,
      };

      document.documentElement.setAttribute(`lang`, lang);
      document.title = TITLES[lang];
      document
        .querySelector(`meta[name="description"]`)
        ?.setAttribute(`content`, DESCRIPTIONS[lang]);
    };

    if (location.pathname === `/`) {
      changeSeoSetting(`ko`);
    } else if (location.pathname === `/en`) {
      changeSeoSetting(`en`);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.search !== ``) navigate(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShowServiceEndModal(isWithinPopupAutoShowPeriod());
  }, [location.pathname]);

  return (
    <>
      <HeaderRouter />
      <MainRouter />
      <FooterRouter />
      {showServiceEndModal &&
        (deviceType === `P` ? (
          <NotiModal closePortal={closeServiceEndModal} language={language} />
        ) : (
          <NotiModalM closePortal={closeServiceEndModal} language={language} />
        ))}
    </>
  );
};
